import { connect } from 'react-redux';
import  GoogleTagManagerView from './GoogleTagManagerView.jsx';
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'google_tag_manager');
  return {
    'integration': integration,
    integrations: state.legacyRootReducer.settings.integrations,
    activeIntegrations: state.legacyRootReducer.settings.integrations.activated,
    deactivating: state.legacyRootReducer.settings.integrations.googleTagManager.deactivation.deactivating
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }
    
  }
}

const GoogleTagManagerPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(GoogleTagManagerView);

export default withUseHooks(GoogleTagManagerPage);